;
define("item_relations_correlated.tpl", function(){});

